import React from 'react'
import cn from 'classnames'

import { IBadgeProps } from './interface'
import './styles.scss'

const bc = 'badge'

const Badge = ({ url, className, alt = 'Badge', isNotAchieved }: IBadgeProps) => (
  <img className={cn(bc, { [className as string]: className, grayscaled: isNotAchieved })} src={url} alt={alt} />
)

export default Badge as React.FunctionComponent<IBadgeProps>
